import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const images = ['https://cdn.magicpatterns.com/uploads/kqFgu3cUG65kx3QZkeTeQZ/IMG_4851.jpg', 'https://cdn.magicpatterns.com/uploads/dMqibUVofhXA9FK9zFXi66/IMG_4852.jpg', 'https://cdn.magicpatterns.com/uploads/gAanQo1UxoPDUKX2Nxix58/IMG_4853.jpg'];
export function PreviewCarousel() {
  const [index, setIndex] = useState(0);
  const next = () => setIndex(i => (i + 1) % images.length);
  const prev = () => setIndex(i => (i - 1 + images.length) % images.length);
  // Autoplay
  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, []);
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-12 px-4 bg-white" data-id="element-96">
      <div className="max-w-5xl mx-auto" data-id="element-97">
        <div className="text-center mb-8" data-id="element-98">
          <h2 className="font-display text-4xl md:text-6xl tracking-wide text-brand-text" data-id="element-99">
            CONTENIDO QUE TE VAS A{' '}
            <span className="text-brand-green" data-id="element-100">ENCONTRAR</span> DENTRO
          </h2>
          <p className="text-brand-muted mt-3 text-base md:text-lg" data-id="element-101">
            Un vistazo real a las páginas del manual
          </p>
        </div>

        <div className="relative" data-id="element-102">
          {/* Carousel viewport */}
          <div className="relative rounded-2xl overflow-hidden bg-brand-surface border border-brand-border shadow-lg cursor-pointer aspect-[3/4] md:aspect-[4/3]" onClick={scrollToCheckout} data-id="element-103">
            <AnimatePresence mode="wait" data-id="element-104">
              <motion.img key={index} src={images[index]} alt={`Vista previa ${index + 1} del manual`} initial={{
              opacity: 0,
              scale: 1.02
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0,
              scale: 0.98
            }} transition={{
              duration: 0.4
            }} className="absolute inset-0 w-full h-full object-contain bg-white" data-id="element-105" />
            </AnimatePresence>
          </div>

          {/* Arrows */}
          <button onClick={prev} aria-label="Anterior" className="absolute left-2 md:-left-5 top-1/2 -translate-y-1/2 bg-white text-brand-green border border-brand-border rounded-full w-12 h-12 flex items-center justify-center shadow-lg hover:bg-brand-green hover:text-white transition-colors z-10" data-id="element-106">
            <ChevronLeft className="w-6 h-6" data-id="element-107" />
          </button>
          <button onClick={next} aria-label="Siguiente" className="absolute right-2 md:-right-5 top-1/2 -translate-y-1/2 bg-white text-brand-green border border-brand-border rounded-full w-12 h-12 flex items-center justify-center shadow-lg hover:bg-brand-green hover:text-white transition-colors z-10" data-id="element-108">
            <ChevronRight className="w-6 h-6" data-id="element-109" />
          </button>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-6" data-id="element-110">
          {images.map((_, i) => <button key={i} onClick={() => setIndex(i)} aria-label={`Ir a la imagen ${i + 1}`} className={`h-2.5 rounded-full transition-all ${i === index ? 'w-8 bg-brand-green' : 'w-2.5 bg-brand-border hover:bg-brand-green/50'}`} data-id="element-111" />)}
        </div>
      </div>
    </section>;
}